import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Typography,
  Input,
  Tag,
  Menu,
  Dropdown,
  Icon,
  Button,
  Modal,
  Select,
  message,
  Badge,
  Avatar,
  Table,
} from "antd";
import moment from "moment";
import { countries } from "constants/CountryList";

import firstPositionBadge from "./images/firstPositionBadge.png";
import firstpositionbackGround from "./images/FirstPositionBackground.png";
import secondPositionBadge from "./images/secondPositionBadge.png";
import thirdPositionBadge from "./images/thirdPositionBadge.png";
const { Text } = Typography;
const { Option } = Select;

const ShowLeaderBoard = (props) => {
  var { leaderboard } = props;

  leaderboard = leaderboard.slice(0, 10);
  return leaderboard.map((user, idx) => {
    const { full_name, contact_number, total_points_shared } = user;
    return (
      <Row style={{}}>
        {idx == 0 ? (
          <Row
            style={{
              backgroundImage: `url(${firstpositionbackGround})`,
              objectFit: "fill",
              borderRadius: "5px",
              marginTop: "16px",
            }}
          >
            <div
              style={{
                marginTop: "18px",
                height: "180px",
              }}
            >
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  marginTop: "16px",
                }}
              >
                <Badge
                  count={
                    <Avatar
                      size={30}
                      src={firstPositionBadge}
                      style={{ marginTop: "8px" }}
                    />
                  }
                >
                  <Avatar
                    size={64}
                    // src={getCountryFlag("India")}
                    style={{
                      border: "2px solid #FFD700",
                      backgroundColor: "#D4A55D",
                      // verticalAlign: "middle"
                      fontSize: "30px",
                    }}
                    gap={10}
                  >
                    {full_name ? full_name[0].toUpperCase() : "U"}
                  </Avatar>
                </Badge>
              </div>
              <div
                style={{
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "12px",
                  textAlign: "center",
                }}
              >
                <Text
                  style={{
                    fontStyle: "normal",
                    fontWeight: "bold",
                    fontSize: "18px",
                    lineHeight: "26px",
                    color: "#181818",

                    // whiteSpace: "nowrap",
                    // ,
                  }}
                >
                  {full_name ? full_name : "Unknown"}
                </Text>
                <Text
                  style={{
                    fontStyle: "normal",
                    fontSize: "14px",
                    lineHeight: "18px",
                    color: "#747474",
                    whiteSpace: "nowrap",
                  }}
                >
                  {contact_number}
                </Text>
                <Text
                  style={{
                    margin: "8px",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: "20px",
                    lineHeight: "32px",
                    color: "#181818",
                    whiteSpace: "nowrap",
                  }}
                >
                  {total_points_shared}
                </Text>
              </div>
            </div>
          </Row>
        ) : (
          <>
            {idx != 0 && (
              <div
                style={{
                  background: "#F2F2F2",
                  height: "1px",
                  marginTop: "16px",
                }}
              ></div>
            )}
            <div
              style={{
                marginTop: "16px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                }}
              >
                {idx <= 2 ? (
                  <Badge
                    count={
                      <Avatar
                        size={23}
                        src={
                          idx !== 1 ? thirdPositionBadge : secondPositionBadge
                        }
                        style={{ marginTop: "8px" }}
                      />
                    }
                  >
                    <Avatar
                      size={50}
                      style={{
                        border: `2px solid ${
                          idx === 1 ? "#C0C0C0" : "#CD7F32"
                        }`,
                        backgroundColor: "#D4A55D",
                        // verticalAlign: "middle"
                        fontSize: "20px",
                      }}
                      gap={10}
                    >
                      {full_name ? full_name[0].toUpperCase() : "U"}
                    </Avatar>
                  </Badge>
                ) : (
                  <Avatar
                    size={50}
                    style={{
                      backgroundColor: "#D4A55D",
                      // verticalAlign: "middle"
                      fontSize: "20px",
                    }}
                    gap={10}
                  >
                    {full_name ? full_name[0].toUpperCase() : "U"}
                  </Avatar>
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "12px",
                    justifyContent: "space-between",
                  }}
                >
                  <Text
                    style={{
                      fontStyle: "normal",
                      fontWeight: "bold",
                      fontSize: "16px",
                      lineHeight: "24px",
                      color: "#181818",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {full_name ? full_name : "Unknown"}
                  </Text>
                  <Text
                    style={{
                      fontStyle: "normal",
                      fontSize: "12px",
                      lineHeight: "22px",
                      color: "#747474",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {contact_number}
                  </Text>
                </div>
              </div>
              <Text
                style={{
                  fontStyle: "normal",
                  fontWeight: "1000",
                  fontSize: "16px",
                  lineHeight: "24px",
                  color: "#181818",
                  whiteSpace: "nowrap",
                }}
              >
                {total_points_shared}
              </Text>
            </div>
          </>
        )}
      </Row>
    );
  });
};
function LeaderBoard(props) {
  return (
    <div style={{}}>
      <Text
        style={{
          color: "#181818",
          fontStyle: "normal",
          fontWeight: "bold",
          fontSize: "20px",
          lineHeight: "32px",
        }}
      >
        Leaderboard
      </Text>
      <ShowLeaderBoard leaderboard={props.leaderboard} />
    </div>
  );
}

export default LeaderBoard;
